import { Information16 } from '@carbon/icons-react';
import { TooltipIcon } from 'carbon-components-react';
import { PROGRAM_KEYS, PROGRAMS } from 'components/accounts/AccountForm/Programs/Programs';
import useAccount from 'hooks/use-account';
import { useMemo } from 'react';
import { dateToPrettyString } from 'util/format-date';
import { dollarAmount } from 'util/format-number';
import styles from './LeadMetrics.module.scss';

const LeadMetrics = ({ data }) => {
    const { account } = useAccount();
    const { features, discountEndTime } = account;
    const activeInAgentMatchProgram = Boolean(features?.[PROGRAM_KEYS.AGENT_MATCH_2024]) && discountEndTime;

    const { spend, lsale, cpl, returnRate, promoBalance } = useMemo(
        () => ({
            spend: dollarAmount(Number(data?.spend || 0)),
            lsale: data?.numSale || 0,
            cpl: dollarAmount(Number(data?.cpl || 0)),
            returnRate: data?.returnRate || 0,
            promoBalance: dollarAmount(Number(data?.[`${PROGRAM_KEYS.AGENT_MATCH_2024}Balance`] || 0))
        }),
        [data]
    );

    const columns = [
        {
            label: 'Leads Purchased',
            value: lsale
        },
        {
            label: 'Lead Spend',
            value: spend
        },
        {
            label: 'Average Cost Per Lead',
            value: cpl
        },
        {
            label: 'Return Percentage',
            value: `${returnRate}%`
        },
        ...(activeInAgentMatchProgram
            ? [
                {
                    label: 'Promotional Balance',
                    value: (
                        <div className={styles.promotionalBalance}>
                            {promoBalance}
                            <TooltipIcon
                                renderIcon={Information16}
                                tooltipText={
                                    <>
                                        {PROGRAMS[PROGRAM_KEYS.AGENT_MATCH_2024]?.agentDescription}{' '}
                                        {discountEndTime &&
                                              `Promotional funds are only valid through ${dateToPrettyString(
                                                  new Date(discountEndTime)
                                              )}.`}
                                    </>
                                }
                            />
                        </div>
                    )
                }
            ]
            : [])
    ];

    return (
        <div className={styles.wrap}>
            {columns.map((col, i) => {
                return (
                    <div className={styles.column} key={i}>
                        <div className={styles.label}>{col.label}</div>
                        <div className={styles.value}>{col.value}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default LeadMetrics;
